export default {
  "Studies available": "Доступно исследований",
  "Studies limit about":
    "Количество исследований, которые можно обработать, ограничено. Для увеличения лимита обратитесь к вашему менеджеру или на sales@3opinion.ai",
  "Studies limit reached":
    "Достигнут лимит обработки исследований. Для увеличения лимита обратитесь к вашему менеджеру или на sales@3opinion.ai",
  "Wait for upload": "Дождитесь окончания текущей загрузки",
  Upload: "Загрузить",
  directory: "Загрузить папку",
  zip: "Загрузить файлы",
  gender: "Пол, \n возраст",
  Name: "Название",
  Status: "Статус обработки",
  studyDate: "Дата исследования",
  uploadDate: "Дата загрузки",
  "Dicom count": "Снимки",
  Action: "Действие",
  Delete: "Удалить",
  "Delete confirm": "Вы уверены, что хотите удалить исследование?",
  "Delete confirm about":
    "При удалении лимит обработки исследований не изменится",
  "No studies": "Нет исследований",
  Search: "Поиск",
  Cancel: "Отмена",
  "Study status none": "Не начата",
  "Study status proccess": "В процессе",
  "Study status not_found": "Патологий не найдено",
  "Study status found": "Найдены патологии",
  Wait: "Ожидание",
  "Zip processed": "Идет сжатие",
  Done: "Готово",
  "Success upload":
    "Файлы успешно загружены. Ожидайте обновления списка исследований",
  "Upload error": "Сервер недоступен, повторите попытку позже",
  "Reach files size":
    "Загузка невозможна. Превышен допустимый суммарный вес файлов",
  "Upload process": "Обработка",
  Yes: "Да",
  No: "Нет",
  "Study in queue": "В очереди",
  "Study in proccess": "Обрабатывается",
  "Study not found": "Патологии не найдены",
  "Study found": "Найдены патологии",
  "Study error": "Ошибка обработки",
  "Study error about":
    "Ошибка загрузки, попробуйте загрузить исследование снова",
  patientID: "ID пациента",
  male_short: "М",
  female_short: "Ж",
  "Wait for anonimization": "Анонимизация",
  "Wait for loading": "Загрузка",
  "Studies title": "Список исследований | " + process.env.VUE_APP_INSTALL_NAME,
  "Error upload": "Формат загруженных файлов не соответствует требованиям",
  undefined__error: "Формат загруженных файлов не соответствует требованиям",
  good: "Хорошо",
  step0:
    "Вы можете загрузить папку с исследованиями, сервис их анонимизирует и обработает с помощью искусственного интеллекта",
  step1:
    "Ваши исследования загружаются, <br> это может занять несколько минут. <br><br> Загрузка работает в фоновом режиме, во время загрузки вы можете просматривать другие исследования.",
  step2:
    "Здесь появится обработанное ИИ исследование. <br><br> Обработка может занять несколько минут, она работает в фоновом режиме. В это время вы можете просматривать другие исследования.",
  "Demo Upload text":
    "Вы сможете обработать свои исследования после регистрации",
  Register: "Регистрация",
  "Demo Banner Text":
    "Создайте аккаунт и получите полный доступ к ИИ сервисам и образовательным курсам",
  Okay: "Понятно",
  "Mobile Notification":
    "При просмотре сайта с мобильного устройства функционал ограничен.<br> Для полного доступа ко всем функциям откройте сайт на компьютере.",
  "Studies limit Demo about":
    "Вы сможете обработать свои исследования в личном кабинете после регистрации",
  "Dicom count v2": "Срезы",
  prev: "Пред.",
  next: "След.",
  "Files select": "Выбрано файлов",
  "Access files": "Подходят под требования сервиса",
  "Access files about": "Они загружаются на сервер для ИИ-анализа",
  "Skip files": "Не подходят",
  "Tags values": "Значения тегов",
  "Skip files about": "не соотвествуют требованиям сервиса",
  Check: "Проверка",
  "Status short": "Статус",
  More: "Увеличить",
  TagError: {
    tail: "<br><br> Выберите другое исследование или <a target='_blank' class='demo__underline demo__color--white' href='https://t.me/thirdopinion_support_bot'>напишите в техподдержку</a>",
    not_exist: "<TAG> исследования не указан",
    some_error:
      "<TAG> исследования <TAG_VALUE> не соответствует требованиям сервиса <RULES>",
    PatientsAge: "Возраст пациента менее 18 лет",
    Modality: "Модальность",
    SliceThickness: "Толщина среза",
    BodyPartExamined: "BodyPartExamined",
    StudyInstanceUID: "StudyInstanceUID",
    SeriesInstanceUID: "SeriesInstanceUID",
  },
  service_h1: {
    base: "Сервис для анализа",
    head_ct: "",
  },
};
